import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Option, FormLabel, Box } from '@mui/joy';

export default function PaidOptionList({
    label,
    required,
    paid,
    setPaid,
    showAll = false,
    disabled = false,
}) {
    const { t } = useTranslation('ui');
    const resolvedLabel = label ?? t('widgets.paymentStatus');
    return (
        <Box sx={{ marginBottom: 2 }}>
            <FormLabel
                sx={{
                    fontWeight: 600,
                    color: '#555',
                    marginBottom: '6px',
                    fontSize: '14px',
                }}
            >
                {required ? `${resolvedLabel} *` : resolvedLabel}
            </FormLabel>
            <Select
                value={paid}
                onChange={(e, newValue) => setPaid(newValue)}
                required={required}
                disabled={disabled}
                placeholder={t('widgets.selectPaymentStatus')}
                sx={{
                    backgroundColor: '#f7f9fc',
                    borderRadius: '8px',
                    padding: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    '&:hover': {
                        borderColor: '#5f09c2',
                    },
                    '&:focus': {
                        borderColor: '#5f09c2',
                        outline: 'none',
                        boxShadow: '0 0 6px rgba(0, 123, 255, 0.5)',
                    },
                    '&[disabled]': {
                        backgroundColor: '#e9ecef',
                        color: '#6c757d',
                        cursor: 'not-allowed',
                    },
                }}
            >
                {showAll && <Option value="">{t('actions.all')}</Option>}
                <Option value={true}>{t('widgets.paid')}</Option>
                <Option value={false}>{t('widgets.notPaid')}</Option>
            </Select>
        </Box>
    );
}
